// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__zY2fe","activeLink":"Header_activeLink__H+QKk"};